"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useHideKnockList = require("./useHideKnockList");
Object.keys(_useHideKnockList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useHideKnockList[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useHideKnockList[key];
    }
  });
});